function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1162883"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.196078%,73.72549%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 0.988281 32 C 0.988281 14.875 14.875 0.988281 32 0.988281 C 49.125 0.988281 63.011719 14.875 63.011719 32 C 63.011719 49.125 49.125 63.011719 32 63.011719 C 14.875 63.011719 0.988281 49.125 0.988281 32 Z M 0.988281 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.300781 25.386719 C 15.585938 25.386719 12.574219 28.398438 12.574219 32.113281 C 12.574219 35.828125 15.585938 38.835938 19.300781 38.835938 C 23.015625 38.835938 26.023438 35.828125 26.023438 32.113281 C 26.023438 28.398438 23.015625 25.386719 19.300781 25.386719 Z M 39.835938 13.425781 C 36.125 13.425781 33.113281 16.4375 33.113281 20.148438 C 33.113281 23.863281 36.125 26.875 39.835938 26.875 C 43.550781 26.875 46.5625 23.863281 46.5625 20.148438 C 46.5625 16.4375 43.550781 13.425781 39.835938 13.425781 Z M 39.835938 37.125 C 36.125 37.125 33.113281 40.136719 33.113281 43.851562 C 33.113281 47.5625 36.125 50.574219 39.835938 50.574219 C 43.550781 50.574219 46.5625 47.5625 46.5625 43.851562 C 46.5625 40.136719 43.550781 37.125 39.835938 37.125 Z M 39.835938 37.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.929688 18.367188 L 40.746094 21.488281 L 20.214844 33.449219 L 18.394531 30.324219 Z M 38.929688 18.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.210938 30.328125 L 40.746094 42.285156 L 38.929688 45.40625 L 18.394531 33.449219 Z M 20.210938 30.328125 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.3dd715fa.svg";
export { ForwardRef as ReactComponent };